import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined"
import { Box } from "@mui/material"
import React, { useContext } from "react"
import { customPalette } from "../../../../theme"
import { AppNavBarContext } from "../../../core/context/nav-bar/AppNavBarContext"
import { ImageDisplayer } from "../../image-displayer/image-displayer"

export function BackButtonNavbar(): React.JSX.Element {
  const { navBarNavigateBack, icon, imageFile } = useContext(AppNavBarContext)

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <ArrowBackOutlinedIcon onClick={navBarNavigateBack} sx={{ cursor: "pointer" }} />

      {imageFile ? (
        <Box display="flex" alignItems="center" sx={{ borderRadius: 2, m: 1 }}>
          <ImageDisplayer file={imageFile} height={55} width={55} isLoading={false} />
        </Box>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          sx={{
            borderRadius: 2,
            background: customPalette.lightGreen12,
            p: 1,
            m: 1,
            border: 3,
            borderColor: customPalette.white,
          }}>
          {icon}
        </Box>
      )}
    </Box>
  )
}
